import { combineReducers } from "redux";
import {
  APPLY_DEALER_STATEMENT_DT_FILTERS,
  CLEAR_DEALER_STATEMENT_DT_FILTERS,
  DO_DEALER_STATEMENT_DT_CLEANUP,
  GET_DEALER_STATEMENT_DT,
  GET_DEALER_STATEMENT_DT_ERR,
  GET_DEALER_STATEMENT_DT_OK,
} from "./actionTypes";

/********** DATATABLE **********/

const defaultDtState = {
  statements: [],
  statementsError: null,
  totalCount: 0,
  listParams: {
    sortBy: 'id',
    sortDir: 'desc',
    pageSize: 50,
    page: 1,
    search: null,
    filters: null,
  },
  isLoadInProgress: false,
};

const Dt = (state = defaultDtState, action) => {
  switch (action.type) {
    case GET_DEALER_STATEMENT_DT:
      state = {
        ...state,
        listParams: action.payload.params,
        statementsError: null,
        isLoadInProgress: true,
      };
      break
    case GET_DEALER_STATEMENT_DT_OK:
      state = {
        ...state,
        statements: action.payload.response.statements,
        totalCount: action.payload.response.totalCount,
        isLoadInProgress: false,
      };
      break
    case GET_DEALER_STATEMENT_DT_ERR:
      state = {
        ...state,
        statements: [],
        totalCount: 0,
        statementsError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_DEALER_STATEMENT_DT_CLEANUP:
      state = {
        ...state,
        statements: [],
        invoicesError: null,
      };
      break
  }
  return state;
}

/********** DATATABLE FILTERS **********/

const defaultDtFiltersState = {
  id: '',
  orderId: '',
  dealerGroupId: '',
  dealerStoreId: '',
  paymentMethod: '',
  effectiveBetween: '',
  paymentPlanId: null,
  _set: false,
};

const DtFilters = (state = defaultDtFiltersState, action) => {
  switch (action.type) {
    case APPLY_DEALER_STATEMENT_DT_FILTERS:
      state = {
        ...defaultDtFiltersState,
        ...action.payload.filters,
        _set: true,
      };
      break
    case CLEAR_DEALER_STATEMENT_DT_FILTERS:
      state = { ...defaultDtFiltersState, _set: false };
      break
  }
  return state;
}

export default combineReducers({
  Dt,
  DtFilters,
});